import FAQ from './FAQ.vue';

export { FAQ };
export default FAQ;
